import { Directive, OnInit, ElementRef, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[hasPrivilege]'
})
export class HasPrivilegeDirective implements OnInit {

    @Input('hasPrivilege') privileges;
    constructor(
        private _element: ElementRef,
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef,
        private _authService: AuthService
    ) {
    }

    ngOnInit(): void {
        this.checkPrivilege();
    }
    checkPrivilege() {
        this._authService.hasPrivilege(this.privileges)
            .then((res) => {
                if (res) {
                    this._viewContainerRef.createEmbeddedView(this._templateRef);
                }
                else {
                    this._viewContainerRef.clear();
                }
            });

    }
}